module.exports = __webpack_public_path__ + "img/rums.71e76566.png";